// O'qish faolligi hisobotlari (backend: management/analytics).
import api from '../../Components/RefreshToken/RefreshToken';

const authHeaders = () => ({
  Accept: 'application/json',
  Authorization: `Bearer ${localStorage.getItem('admin_token')}`,
});

// GET /management/analytics/learners/{learner_id}?days= — talabaning bitta kursdagi faolligi
export const fetchLearnerReport = (learnerId, days, signal) =>
  api
    .get(`/management/analytics/learners/${learnerId}`, { params: { days }, headers: authHeaders(), signal })
    .then((res) => res.data);

// GET /management/analytics/courses/{course_id}?days= — kurs bo'yicha
export const fetchCourseReport = (courseId, days, signal) =>
  api
    .get(`/management/analytics/courses/${courseId}`, { params: { days }, headers: authHeaders(), signal })
    .then((res) => res.data);

// GET /courses — kurs tanlash ro'yxati (Studentlar sahifasidagi bilan bir xil)
export const fetchCourses = (signal) =>
  api.get('/courses', { headers: authHeaders(), signal }).then((res) => (Array.isArray(res.data) ? res.data : []));
